// third-party
import { FormattedMessage } from 'react-intl';

// assets
import BulbOutlined from '@ant-design/icons/BulbOutlined';

// type
import { NavItemType } from '@trendiolive/trendio-selfcare-ui-kit';

import {
  MARKET_INTELLIGENCE_BEST_SELLING_CREATORS_PATH,
  MARKET_INTELLIGENCE_BEST_SELLING_LIVES_PATH,
  MARKET_INTELLIGENCE_BEST_SELLING_PRODUCTS_PATH,
  MARKET_INTELLIGENCE_BEST_SELLING_VIDEOS_PATH
} from 'constants/routeConstants';

// icons
const icons = { BulbOutlined };

// ==============================|| MENU ITEMS - MARKET INTELLIGENCE ||============================== //

const marketIntelligence: NavItemType = {
  id: 'market-intelligence-menu',
  type: 'group',
  children: [
    {
      id: 'market-intelligence',
      title: <FormattedMessage id="market-intelligence" />,
      type: 'collapse',
      icon: icons.BulbOutlined,
      children: [
        {
          id: 'best-selling-products',
          title: <FormattedMessage id="best-selling-products" />,
          type: 'item',
          url: MARKET_INTELLIGENCE_BEST_SELLING_PRODUCTS_PATH
        },
        {
          id: 'best-selling-creators',
          title: <FormattedMessage id="best-selling-creators" />,
          type: 'item',
          url: MARKET_INTELLIGENCE_BEST_SELLING_CREATORS_PATH
        },
        {
          id: 'best-selling-videos',
          title: <FormattedMessage id="best-selling-videos" />,
          type: 'item',
          url: MARKET_INTELLIGENCE_BEST_SELLING_VIDEOS_PATH
        },
        {
          id: 'best-selling-lives',
          title: <FormattedMessage id="best-selling-lives" />,
          type: 'item',
          url: MARKET_INTELLIGENCE_BEST_SELLING_LIVES_PATH
        }
      ]
    }
  ]
};

export default marketIntelligence;
